<script setup lang="ts">
    import { nextTick, ref, watch } from 'vue';
    import { __ } from '../../stores/expressions';
    import ChatMessage from './ChatMessage.vue';
    import { IChatMessage, IChatMessagePromptContent } from '@/js/services/api/chat/chat';
    import ChatMessageRows from './ChatMessageRows.vue';
    import { EllipsisIcon, XIcon } from '@lucide/vue';

    defineProps<{ message: IChatMessage }>();

    const emit = defineEmits<{
        (e: 'scrollTo', value: number): void;
    }>();

    const prompt = ref(false);

    const messageContainer = ref<HTMLDivElement | null>(null);

    watch(
        () => prompt.value,
        (open) => {
            nextTick(() => {
                emit('scrollTo', (messageContainer.value?.getBoundingClientRect().top || 0) - 32);
            });
        }
    );
</script>

<template>
    <ChatMessage :message="message">
        <div ref="messageContainer">
            <ChatMessageRows :message="message" />
        </div>

        <template #footer>
            <button
                v-if="!prompt"
                class="Icon-button -mt-2 size-8 mr-1 cursor-pointer"
                :aria-label="__('toggle-prompt')"
                @click="prompt = true"
            >
                <EllipsisIcon class="size-8" />
            </button>
        </template>

        <template v-if="prompt" #after>
            <div
                class="bg-white min-h-8 text-xs p-4 pr-8 rounded-lg border border-gray-light relative mt-1.5"
            >
                <button class="Icon-button size-5 absolute top-0 right-0" @click="prompt = false">
                    <XIcon class="size-4" />
                </button>
                <template v-if="message.content">
                    {{ (message.content as IChatMessagePromptContent).prompt }}
                </template>
            </div>
        </template>
    </ChatMessage>
</template>
